// eslint-disable-next-line no-shadow
export const KYCLevels = ['None', 'LocationChecked', 'Full'] as const
export type KYCLevel = (typeof KYCLevels)[number]

export const AuthKeeperABI = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'permissionManager_',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]',
      },
    ],
    name: 'BlacklistAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]',
      },
    ],
    name: 'BlacklistRemoved',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]',
      },
      {
        indexed: false,
        internalType: 'enum AuthKeeper.KYCLevel',
        name: 'level',
        type: 'uint8',
      },
    ],
    name: 'KYCLevelBatchSet',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'accounts',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'enum AuthKeeper.KYCLevel',
        name: 'level',
        type: 'uint8',
      },
    ],
    name: 'KYCLevelSet',
    type: 'event',
  },
  {
    inputs: [],
    name: 'AUTH_KEEPER_ADMIN_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'accounts_',
        type: 'address[]',
      },
    ],
    name: 'addToBlacklist',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'accounts_',
        type: 'address[]',
      },
      {
        internalType: 'enum AuthKeeper.KYCLevel',
        name: 'level_',
        type: 'uint8',
      },
    ],
    name: 'batchSetKYCLevel',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account_',
        type: 'address',
      },
    ],
    name: 'getKYCLevel',
    outputs: [
      {
        internalType: 'enum AuthKeeper.KYCLevel',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account_',
        type: 'address',
      },
    ],
    name: 'isBlacklisted',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'permissionManager',
    outputs: [
      {
        internalType: 'contract IPermissionManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'accounts_',
        type: 'address[]',
      },
    ],
    name: 'removeFromBlacklist',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account_',
        type: 'address',
      },
      {
        internalType: 'enum AuthKeeper.KYCLevel',
        name: 'level_',
        type: 'uint8',
      },
    ],
    name: 'setKYCLevel',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'permissionManager_',
        type: 'address',
      },
    ],
    name: 'setPermissionManager',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const
